import React from 'react';

const Blog = () => {
  return (
    <div className="container mt-5">
      <h1>Blog</h1>
      <p>Coming soon! Check back later for articles, news, and updates.</p>
    </div>
  );
};

export default Blog;
